import { useMemo, useState } from 'react';

import { useV2RolloverSessions } from '~entities/session/api/session-rollover';

import type { SessionOption } from '~features/shared/session-selector';

import Select from '~shared/components/select/select';
import { useDebounce } from '~shared/shadcn/expansions/multiple-selector';

interface SessionRolloverSelectorProps {
  session: SessionOption | null;
  onChange: (value: SessionOption | null) => void;
  includeArchivedSessions?: boolean;
}

export function SessionRolloverSelector({
  session,
  onChange,
  includeArchivedSessions = false,
}: SessionRolloverSelectorProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const { data, isFetching } = useV2RolloverSessions({
    name: debouncedSearchQuery || undefined,
    limit: 50,
    includeArchivedSessions,
  });

  const options = useMemo(() => {
    const next = (data?.sessions ?? []).map((item) => ({
      label: item.name,
      value: item._id,
    }));
    if (session && !next.some((item) => item.value === session.value)) {
      next.push(session);
    }
    return next;
  }, [data?.sessions, session]);

  return (
    <Select
      isClearable
      value={session ?? undefined}
      onChange={(option) => {
        onChange((option as SessionOption | null | undefined) ?? null);
      }}
      placeholder='Choose a session'
      options={options}
      isLoading={isFetching}
      onInputChange={setSearchQuery}
    />
  );
}
